import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/lighthouse-check")({
  beforeLoad: () => {
    throw redirect({ to: "/en/tools/lighthouse-check", replace: true });
  },
});
